var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHero2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "gridItem__media",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 1600,
    height: 1200,
    viewBox: "0 0 1600 1200",
    style: {
      baselineShift: 0,
      clipRule: "nonzero",
      color: "rgb(61, 61, 61)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      cursor: "auto",
      direction: "ltr",
      display: "block",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      font: "400 16px / 18.4px Lato, sans-serif",
      imageRendering: "auto",
      letterSpacing: "normal",
      marker: "none",
      overflow: "hidden",
      paintOrder: "normal",
      pointerEvents: "auto",
      shapeRendering: "auto",
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      textAnchor: "start",
      textDecoration: "none solid rgb(61, 61, 61)",
      textRendering: "auto",
      visibility: "visible",
      wordSpacing: 0,
      writingMode: "horizontal-tb"
    },
    fill: "none",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M321 1088.08L223.68 617.56C222.472 602.769 226.582 588.031 235.27 576L511.57 239C517.884 230.259 526.36 223.308 536.168 218.828C545.976 214.347 556.779 212.491 567.52 213.44L1166.46 244.77C1179.26 245.897 1191.41 250.959 1201.22 259.261C1211.03 267.563 1218.04 278.699 1221.27 291.14L1392.41 658.91C1395.14 669.428 1395.07 680.477 1392.21 690.96L1263.45 1089.55L321 1088.08Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(90, 95, 101)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M321 1088.08L223.68 617.56C222.472 602.769 226.582 588.031 235.27 576L511.57 239C517.884 230.259 526.36 223.308 536.168 218.828C545.976 214.347 556.779 212.491 567.52 213.44L1166.46 244.77C1179.26 245.897 1191.41 250.959 1201.22 259.261C1211.03 267.563 1218.04 278.699 1221.27 291.14L1392.41 658.91C1395.14 669.428 1395.07 680.477 1392.21 690.96L1263.45 1089.55L321 1088.08Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.24 329H861.06V569.51H945.24V329Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.22 335.87H867.07V382.25H939.22V335.87Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(43, 131, 252)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.22 388.27H867.07V434.65H939.22V388.27Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(43, 131, 252)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M939.22 335.87H867.07V382.25H939.22V335.87Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M939.22 388.27H867.07V434.65H939.22V388.27Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.22 440.66H867.07V487.04H939.22V440.66Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(43, 131, 252)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.22 493.06H867.07V539.44H939.22V493.06Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(43, 131, 252)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M939.22 493.06H867.07V539.44H939.22V493.06Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.05 440.893L1080.75 378.315L901.958 539.185L958.263 601.763L1137.05 440.893Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.91 441.015L1079.65 387.38L1045.18 418.403L1093.43 472.038L1127.91 441.015Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 187, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.96 476.065L1040.71 422.43L1006.23 453.452L1054.49 507.087L1088.96 476.065Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 187, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1127.91 441.015L1079.65 387.38L1045.18 418.403L1093.43 472.038L1127.91 441.015Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1088.96 476.065L1040.71 422.43L1006.23 453.452L1054.49 507.087L1088.96 476.065Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.01 511.107L1001.75 457.473L967.277 488.495L1015.54 542.13L1050.01 511.107Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 187, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.06 546.157L962.797 492.522L928.319 523.544L976.578 577.179L1011.06 546.157Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 187, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1011.06 546.157L962.797 492.522L928.319 523.544L976.578 577.179L1011.06 546.157Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.71 1090.85H281.29C280.934 1090.79 280.611 1090.61 280.377 1090.33C280.144 1090.06 280.016 1089.71 280.016 1089.35C280.016 1088.99 280.144 1088.64 280.377 1088.37C280.611 1088.09 280.934 1087.91 281.29 1087.85H1304.71C1305.07 1087.91 1305.39 1088.09 1305.62 1088.37C1305.86 1088.64 1305.98 1088.99 1305.98 1089.35C1305.98 1089.71 1305.86 1090.06 1305.62 1090.33C1305.39 1090.61 1305.07 1090.79 1304.71 1090.85V1090.85Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(90, 95, 101)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    style: {
      baselineShift: 0,
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1304.71 1090.85H281.29C280.934 1090.79 280.611 1090.61 280.377 1090.33C280.144 1090.06 280.016 1089.71 280.016 1089.35C280.016 1088.99 280.144 1088.64 280.377 1088.37C280.611 1088.09 280.934 1087.91 281.29 1087.85H1304.71C1305.07 1087.91 1305.39 1088.09 1305.62 1088.37C1305.86 1088.64 1305.98 1088.99 1305.98 1089.35C1305.98 1089.71 1305.86 1090.06 1305.62 1090.33C1305.39 1090.61 1305.07 1090.79 1304.71 1090.85V1090.85Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1198.81 513.06H405.55C397.503 513.06 390.98 519.583 390.98 527.63V1065.66C390.98 1073.71 397.503 1080.23 405.55 1080.23H1198.81C1206.86 1080.23 1213.38 1073.71 1213.38 1065.66V527.63C1213.38 519.583 1206.86 513.06 1198.81 513.06Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(90, 95, 101)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1198.81 513.06H405.55C397.503 513.06 390.98 519.583 390.98 527.63V1065.66C390.98 1073.71 397.503 1080.23 405.55 1080.23H1198.81C1206.86 1080.23 1213.38 1073.71 1213.38 1065.66V527.63C1213.38 519.583 1206.86 513.06 1198.81 513.06Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M357.74 1038.28H1248.74V1070.11C1248.74 1074.83 1246.86 1079.36 1243.53 1082.7C1240.19 1086.03 1235.66 1087.91 1230.94 1087.91H375.54C370.819 1087.91 366.292 1086.03 362.954 1082.7C359.616 1079.36 357.74 1074.83 357.74 1070.11V1038.28Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(90, 95, 101)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      baselineShift: 0,
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M357.74 1038.28H1248.74V1070.11C1248.74 1074.83 1246.86 1079.36 1243.53 1082.7C1240.19 1086.03 1235.66 1087.91 1230.94 1087.91H375.54C370.819 1087.91 366.292 1086.03 362.954 1082.7C359.616 1079.36 357.74 1074.83 357.74 1070.11V1038.28Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1190.15 535.59H414.2V1014.56H1190.15V535.59Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 187, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    style: {
      baselineShift: 0,
      opacity: 0.8,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1190.15 535.59H414.2V1014.56H1190.15V535.59Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1213.38 1040.32C1213.38 1040.04 1029.26 1039.82 802.2 1039.82C575.14 1039.82 390.98 1040.04 390.98 1040.32C390.98 1040.6 575.05 1040.82 802.2 1040.82C1029.35 1040.82 1213.38 1040.59 1213.38 1040.32Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M715.05 1040.28H891.42L882.07 1056.36H724.79L715.05 1040.28Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.39 912.65L606.16 938.56C608.178 941.703 608.888 945.509 608.141 949.168C607.394 952.827 605.248 956.05 602.16 958.15L542 995.21L531.45 981.62L571 943.08L563 931.19L590.39 912.65Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.9 912.65L381.14 938.56C379.12 941.702 378.408 945.509 379.155 949.169C379.903 952.828 382.05 956.051 385.14 958.15L447 995.21L457.55 981.62L416.3 943.08L424.35 931.19L396.9 912.65Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.53 852.36L472.59 850.87L435.19 858.37C432.198 858.898 429.35 860.046 426.829 861.741C424.307 863.435 422.169 865.639 420.55 868.21L394.94 913.66L423.87 933.17L437.87 912.78V998.84H549.87V912.78L562.48 932.18L592 913.64L567 868.02C565.347 865.308 563.119 862.991 560.474 861.232C557.829 859.473 554.831 858.315 551.69 857.84L515.46 852.36",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(43, 131, 252)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.11 812.4L471.73 851.79C471.72 852.674 471.997 853.537 472.52 854.25L472.87 854.86C482.23 869.36 505.11 864.72 512.48 857.24C513.084 856.732 513.546 856.076 513.823 855.337C514.1 854.598 514.181 853.8 514.06 853.02L507.48 809.5L472.11 812.4Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.34 794.5C511.34 794.5 518.53 842.06 492.34 843.99C466.71 845.92 465.92 797.83 465.92 797.83L465.22 784.06L498.22 778.26L506.56 782.56L511.34 794.5Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M512 840L510 827C507.63 835.43 502.72 842.45 494.12 843.85H494.21L492.36 844.11C485.52 844.64 479.82 841.48 475.52 834.73C475.481 834.665 475.43 834.608 475.368 834.564C475.307 834.519 475.237 834.488 475.163 834.471C475.09 834.454 475.013 834.452 474.939 834.466C474.864 834.48 474.793 834.508 474.73 834.55C474.666 834.59 474.611 834.642 474.567 834.703C474.523 834.765 474.492 834.834 474.475 834.907C474.458 834.981 474.456 835.057 474.469 835.131C474.482 835.205 474.51 835.276 474.55 835.34C479.11 842.53 485.17 845.87 492.45 845.34C493.973 845.236 495.478 844.943 496.93 844.47C502.343 844.997 507.749 843.393 512 840Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.11 783.88C505.11 783.88 513.44 778.35 517.39 787.88C520.73 795.88 515.11 804.55 515.11 804.55L510.28 804.02C508.28 803.94 506.86 802.97 506.69 801.02L505.11 783.88Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.07 778.09C511.78 787.09 504.07 789.5 500.89 789.76L475 792C473.987 792.101 473.051 792.585 472.382 793.352C471.713 794.119 471.362 795.113 471.4 796.13L471.84 804.38C471.883 804.923 471.717 805.462 471.374 805.887C471.032 806.311 470.54 806.587 470 806.66L468.42 806.83L466.66 809.03C456.48 806.57 452.27 777.7 470.96 771.91C471.96 771.582 472.886 771.06 473.684 770.373C474.482 769.687 475.136 768.85 475.61 767.91C478.33 762.29 489.48 760.8 495.09 767.12C495.637 767.766 496.326 768.276 497.104 768.611C497.881 768.946 498.725 769.096 499.57 769.05C506.33 768.88 510.72 773.09 511.07 778.09Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.59 818.67C482.041 818.67 482.482 818.536 482.857 818.286C483.232 818.035 483.524 817.679 483.697 817.262C483.869 816.846 483.914 816.387 483.826 815.945C483.738 815.503 483.521 815.097 483.202 814.778C482.883 814.459 482.477 814.242 482.035 814.154C481.593 814.066 481.134 814.111 480.718 814.284C480.301 814.456 479.945 814.748 479.694 815.123C479.444 815.498 479.31 815.939 479.31 816.39C479.31 816.995 479.55 817.575 479.978 818.002C480.405 818.43 480.985 818.67 481.59 818.67Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.7 817.82C481.84 817.82 481.975 817.764 482.075 817.665C482.174 817.565 482.23 817.431 482.23 817.29C482.23 817.149 482.174 817.015 482.075 816.915C481.975 816.816 481.84 816.76 481.7 816.76C481.559 816.76 481.425 816.816 481.325 816.915C481.226 817.015 481.17 817.149 481.17 817.29C481.17 817.431 481.226 817.565 481.325 817.665C481.425 817.764 481.559 817.82 481.7 817.82V817.82Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.14 817.36C499.594 817.362 500.038 817.229 500.416 816.978C500.794 816.727 501.089 816.37 501.264 815.951C501.438 815.532 501.484 815.071 501.396 814.626C501.308 814.181 501.09 813.772 500.769 813.451C500.448 813.13 500.039 812.912 499.594 812.824C499.149 812.736 498.688 812.782 498.269 812.956C497.85 813.131 497.493 813.426 497.242 813.804C496.991 814.182 496.858 814.626 496.86 815.08C496.86 815.685 497.1 816.265 497.528 816.692C497.955 817.12 498.535 817.36 499.14 817.36V817.36Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.25 816.59C499.391 816.59 499.526 816.534 499.625 816.435C499.724 816.335 499.78 816.201 499.78 816.06C499.78 815.919 499.724 815.785 499.625 815.685C499.526 815.586 499.391 815.53 499.25 815.53C499.11 815.53 498.975 815.586 498.875 815.685C498.776 815.785 498.72 815.919 498.72 816.06C498.72 816.201 498.776 816.335 498.875 816.435C498.975 816.534 499.11 816.59 499.25 816.59V816.59Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M491.51 824.86L493.35 824.68C493.443 824.683 493.534 824.667 493.62 824.632C493.706 824.598 493.783 824.545 493.847 824.479C493.911 824.412 493.961 824.333 493.993 824.247C494.024 824.16 494.037 824.067 494.031 823.975C494.025 823.883 493.999 823.793 493.956 823.712C493.913 823.63 493.853 823.558 493.78 823.501C493.707 823.444 493.624 823.403 493.534 823.38C493.445 823.358 493.351 823.354 493.26 823.37L491.42 823.54C491.235 823.556 491.049 823.535 490.873 823.477C490.697 823.42 490.534 823.327 490.395 823.204C490.255 823.082 490.142 822.932 490.062 822.765C489.983 822.597 489.938 822.415 489.93 822.23C489.915 822.045 489.937 821.859 489.996 821.683C490.054 821.506 490.147 821.343 490.269 821.204C490.391 821.064 490.54 820.95 490.707 820.869C490.873 820.787 491.055 820.74 491.24 820.73C491.332 820.733 491.424 820.717 491.51 820.682C491.596 820.648 491.673 820.595 491.737 820.529C491.801 820.462 491.851 820.383 491.883 820.297C491.914 820.21 491.927 820.117 491.921 820.025C491.915 819.933 491.889 819.843 491.846 819.762C491.803 819.68 491.743 819.608 491.67 819.551C491.597 819.494 491.514 819.453 491.424 819.431C491.335 819.408 491.241 819.404 491.15 819.42C490.796 819.438 490.449 819.529 490.131 819.686C489.812 819.844 489.53 820.065 489.3 820.335C489.071 820.606 488.899 820.921 488.796 821.261C488.693 821.6 488.66 821.957 488.7 822.31C488.7 822.667 488.774 823.021 488.919 823.348C489.064 823.675 489.275 823.968 489.54 824.208C489.805 824.448 490.117 824.63 490.456 824.743C490.795 824.855 491.154 824.895 491.51 824.86Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561 1055.11L539 1051.11L536.08 1072.11L557.65 1074.45L561 1055.11Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M539.38 1072.27L547 1052L546.7 1062.48C546.793 1062.96 547.037 1063.4 547.396 1063.73C547.756 1064.07 548.213 1064.27 548.7 1064.33L559.17 1065.64L557.65 1074.36L539.4 1072.26L539.38 1072.27Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.48 1088.41C571.618 1087.86 568.076 1085.95 565.48 1083.04L562.48 1079.61C560.653 1077.53 558.312 1075.96 555.69 1075.07C553.543 1074.32 551.723 1072.85 550.544 1070.9C549.366 1068.96 548.901 1066.66 549.23 1064.41L549.29 1063.97C549.68 1061.24 551.131 1058.78 553.329 1057.12C555.526 1055.46 558.291 1054.74 561.02 1055.11L579.79 1057.72L575.48 1088.41Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(43, 131, 252)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 1073.15C557.84 1073.15 557.55 1073.15 557.5 1072.93C556.746 1071.07 556.495 1069.04 556.772 1067.05C557.05 1065.06 557.846 1063.18 559.08 1061.6C559.115 1061.56 559.156 1061.54 559.201 1061.52C559.247 1061.5 559.296 1061.49 559.345 1061.49C559.395 1061.49 559.443 1061.5 559.489 1061.52C559.534 1061.54 559.576 1061.56 559.61 1061.6C559.647 1061.63 559.676 1061.67 559.696 1061.72C559.716 1061.77 559.726 1061.82 559.726 1061.86C559.726 1061.91 559.716 1061.96 559.696 1062.01C559.676 1062.06 559.647 1062.1 559.61 1062.13C558.45 1063.59 557.702 1065.34 557.444 1067.19C557.185 1069.04 557.426 1070.92 558.14 1072.65C558.166 1072.68 558.184 1072.72 558.193 1072.76C558.201 1072.8 558.2 1072.84 558.19 1072.88C558.153 1072.99 558.087 1073.08 558 1073.15Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.51 1074.69C560.36 1074.75 560.06 1074.69 560.02 1074.47C559.265 1072.61 559.013 1070.58 559.291 1068.59C559.568 1066.6 560.365 1064.72 561.6 1063.14C561.634 1063.1 561.674 1063.08 561.719 1063.06C561.763 1063.04 561.812 1063.03 561.86 1063.03C561.909 1063.03 561.957 1063.04 562.001 1063.06C562.046 1063.08 562.086 1063.1 562.12 1063.14C562.155 1063.17 562.184 1063.22 562.203 1063.26C562.222 1063.31 562.232 1063.36 562.232 1063.41C562.232 1063.45 562.222 1063.5 562.203 1063.55C562.184 1063.59 562.155 1063.64 562.12 1063.67C560.957 1065.13 560.207 1066.88 559.949 1068.73C559.69 1070.58 559.932 1072.47 560.65 1074.19C560.666 1074.23 560.675 1074.27 560.675 1074.31C560.675 1074.34 560.666 1074.38 560.65 1074.42C560.68 1074.57 560.59 1074.7 560.51 1074.69Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.12 1076.48C562.96 1076.48 562.66 1076.48 562.62 1076.26C561.864 1074.4 561.612 1072.37 561.889 1070.38C562.167 1068.39 562.964 1066.51 564.2 1064.93C564.234 1064.9 564.275 1064.87 564.32 1064.85C564.365 1064.83 564.413 1064.82 564.462 1064.82C564.51 1064.82 564.559 1064.83 564.604 1064.85C564.649 1064.86 564.69 1064.89 564.725 1064.93C564.76 1064.96 564.788 1065 564.807 1065.04C564.826 1065.09 564.836 1065.14 564.836 1065.19C564.837 1065.24 564.828 1065.28 564.81 1065.33C564.791 1065.37 564.764 1065.42 564.73 1065.45C563.567 1066.91 562.818 1068.66 562.559 1070.51C562.301 1072.37 562.543 1074.25 563.26 1075.98C563.276 1076.02 563.285 1076.06 563.285 1076.09C563.285 1076.13 563.276 1076.17 563.26 1076.21C563.256 1076.26 563.242 1076.31 563.218 1076.36C563.194 1076.41 563.16 1076.45 563.12 1076.48V1076.48Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578 1088.84L575.5 1088.49L579.79 1057.73L582.29 1058.08C582.464 1058.1 582.633 1058.16 582.784 1058.25C582.936 1058.34 583.069 1058.46 583.175 1058.6C583.281 1058.74 583.359 1058.9 583.402 1059.07C583.446 1059.24 583.455 1059.42 583.43 1059.59L579.52 1087.59C579.482 1087.96 579.301 1088.29 579.017 1088.53C578.732 1088.76 578.367 1088.87 578 1088.84Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(43, 131, 252)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M578 1088.84L575.5 1088.49L579.79 1057.73L582.29 1058.08C582.464 1058.1 582.633 1058.16 582.784 1058.25C582.936 1058.34 583.069 1058.46 583.175 1058.6C583.281 1058.74 583.359 1058.9 583.402 1059.07C583.446 1059.24 583.455 1059.42 583.43 1059.59L579.52 1087.59C579.482 1087.96 579.301 1088.29 579.017 1088.53C578.732 1088.76 578.367 1088.87 578 1088.84Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.66 1072.15L450.1 1068.8L446.19 1048L424.39 1053.08L428.66 1072.15Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M444.07 1069.7L428.66 1072.15L426.73 1063.52L437.13 1061.71C437.611 1061.63 438.054 1061.4 438.395 1061.05C438.736 1060.7 438.959 1060.25 439.03 1059.77L441.79 1049.01L444.15 1069.69L444.07 1069.7Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.77 1056.57L424.39 1053.07C427.1 1052.57 429.899 1053.16 432.174 1054.71C434.449 1056.27 436.016 1058.66 436.53 1061.37L436.62 1061.81C437.06 1064.06 436.701 1066.38 435.605 1068.39C434.509 1070.4 432.746 1071.96 430.62 1072.81C428.044 1073.83 425.779 1075.51 424.05 1077.67L421.17 1081.24C418.725 1084.27 415.284 1086.34 411.46 1087.07L405.77 1056.57Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(43, 131, 252)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428 1070.69C427.981 1070.65 427.971 1070.61 427.971 1070.57C427.971 1070.53 427.981 1070.49 428 1070.45C428.631 1068.69 428.779 1066.79 428.427 1064.96C428.075 1063.12 427.237 1061.41 426 1060.01C425.965 1059.98 425.937 1059.94 425.918 1059.89C425.899 1059.85 425.889 1059.8 425.889 1059.75C425.889 1059.7 425.899 1059.65 425.918 1059.61C425.937 1059.56 425.965 1059.52 426 1059.49C426.034 1059.45 426.075 1059.42 426.12 1059.4C426.166 1059.38 426.215 1059.37 426.265 1059.37C426.315 1059.37 426.364 1059.38 426.41 1059.4C426.455 1059.42 426.496 1059.45 426.53 1059.49C427.837 1061.02 428.72 1062.86 429.09 1064.83C429.461 1066.81 429.305 1068.84 428.64 1070.74C428.64 1070.97 428.32 1071.03 428.16 1070.98C428.077 1070.9 428.02 1070.8 428 1070.69V1070.69Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.6 1072.35C425.581 1072.31 425.57 1072.28 425.57 1072.24C425.57 1072.19 425.581 1072.16 425.6 1072.12C426.231 1070.36 426.378 1068.46 426.026 1066.62C425.674 1064.78 424.837 1063.07 423.6 1061.67C423.564 1061.64 423.536 1061.6 423.516 1061.55C423.496 1061.51 423.485 1061.46 423.484 1061.41C423.482 1061.36 423.49 1061.31 423.508 1061.27C423.525 1061.22 423.551 1061.18 423.585 1061.15C423.618 1061.11 423.658 1061.08 423.703 1061.06C423.747 1061.04 423.795 1061.03 423.844 1061.03C423.893 1061.03 423.941 1061.04 423.987 1061.05C424.033 1061.07 424.074 1061.1 424.11 1061.13C425.419 1062.65 426.303 1064.49 426.673 1066.47C427.044 1068.44 426.887 1070.48 426.22 1072.37C426.22 1072.6 425.9 1072.66 425.74 1072.61C425.58 1072.56 425.62 1072.49 425.6 1072.35Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.08 1074.26C423.05 1074.19 423.05 1074.1 423.08 1074.03C423.71 1072.27 423.856 1070.37 423.505 1068.53C423.153 1066.69 422.316 1064.98 421.08 1063.58C421.045 1063.55 421.017 1063.51 420.998 1063.46C420.979 1063.42 420.969 1063.37 420.969 1063.32C420.969 1063.27 420.979 1063.22 420.998 1063.18C421.017 1063.13 421.045 1063.09 421.08 1063.06C421.113 1063.02 421.153 1062.99 421.197 1062.97C421.242 1062.95 421.291 1062.94 421.34 1062.94C421.389 1062.94 421.437 1062.95 421.482 1062.97C421.527 1062.99 421.567 1063.02 421.6 1063.06C422.911 1064.58 423.798 1066.42 424.17 1068.4C424.542 1070.37 424.387 1072.41 423.72 1074.3C423.72 1074.53 423.39 1074.59 423.23 1074.54C423.145 1074.47 423.091 1074.37 423.08 1074.26Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.38 1086.43L402.15 1058.62C402.117 1058.45 402.118 1058.27 402.154 1058.1C402.19 1057.92 402.259 1057.76 402.359 1057.61C402.458 1057.47 402.585 1057.34 402.733 1057.25C402.881 1057.15 403.046 1057.08 403.22 1057.05L405.7 1056.59L411.44 1087.11L408.96 1087.57C408.6 1087.62 408.234 1087.53 407.939 1087.32C407.644 1087.11 407.444 1086.79 407.38 1086.43V1086.43Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(43, 131, 252)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M407.38 1086.43L402.15 1058.62C402.117 1058.45 402.118 1058.27 402.154 1058.1C402.19 1057.92 402.259 1057.76 402.359 1057.61C402.458 1057.47 402.585 1057.34 402.733 1057.25C402.881 1057.15 403.046 1057.08 403.22 1057.05L405.7 1056.59L411.44 1087.11L408.96 1087.57C408.6 1087.62 408.234 1087.53 407.939 1087.32C407.644 1087.11 407.444 1086.79 407.38 1086.43V1086.43Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.89 828.46L497.03 827.67C497.3 827.67 497.56 827.93 497.47 828.19C497.132 829.443 496.415 830.562 495.419 831.394C494.423 832.226 493.194 832.731 491.901 832.84C490.607 832.949 489.311 832.657 488.189 832.004C487.068 831.351 486.174 830.369 485.63 829.19V829.1C485.58 829.047 485.547 828.981 485.533 828.909C485.52 828.838 485.527 828.764 485.555 828.697C485.582 828.629 485.628 828.571 485.688 828.529C485.747 828.487 485.817 828.463 485.89 828.46V828.46Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M542 995.21L541.06 995.86L602.18 958.15C605.266 956.048 607.41 952.825 608.157 949.167C608.904 945.509 608.195 941.703 606.18 938.56L603.11 933.56C603.11 933.56 611 947.06 592 959L538.5 993.05L542 995.21Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M391.72 957.56C378.86 951.35 382.25 936.72 382.25 936.72L381.14 938.56C379.12 941.702 378.408 945.509 379.155 949.169C379.903 952.828 382.05 956.051 385.14 958.15L447.29 995.21L445.88 994.48L450.14 991.48L391.72 957.56Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.15,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.21 990.06L437.89 995.79H549.92L598.03 990.06L589.65 1040.64H407.63L388.97 991.5",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 187, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M387.21 990.06L437.89 995.79H549.92L598.03 990.06L589.65 1040.64H407.63L388.97 991.5",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.82 1030.09L575 997.22C583.42 993.857 592.12 991.243 601 989.41V989.41C605.811 988.417 610.816 989.072 615.21 991.27C621.352 994.33 626.028 999.704 628.21 1006.21L628.64 1007.5C630.488 1012.99 630.082 1018.99 627.51 1024.18V1024.18C626.087 1027.06 624.05 1029.58 621.543 1031.58C619.035 1033.58 616.119 1035.01 613 1035.76L445.59 1075.59L438.67 1048.88L492.82 1030.09Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 187, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M627.52 1024.18C630.092 1018.99 630.499 1012.99 628.65 1007.5L628.22 1006.21C626.962 1002.45 624.854 999.026 622.06 996.21C622.06 996.21 630.28 1024.34 600.62 1030.77L559.22 1040.92C553.122 1042.41 546.76 1042.46 540.64 1041.06L493.7 1030.35L509.65 1060.35L613 1035.76C616.121 1035.01 619.039 1033.59 621.549 1031.59C624.058 1029.58 626.096 1027.06 627.52 1024.18V1024.18Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.7 1030.36L411.49 997.5C403.072 994.132 394.371 991.519 385.49 989.69V989.69C380.68 988.694 375.675 989.346 371.28 991.54V991.54C365.14 994.603 360.465 999.976 358.28 1006.48L357.85 1007.77C356.005 1013.26 356.415 1019.26 358.99 1024.45V1024.45C360.421 1027.33 362.468 1029.85 364.984 1031.85C367.5 1033.84 370.425 1035.26 373.55 1036L543.07 1075.83L547.88 1049.12L493.7 1030.36Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 187, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M439.62 1053.28L481.11 1067.13L492.62 1064.37L439.32 1051.72L439.62 1053.28Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M544.24 1071.78L398.46 1033.05C394.96 1032.05 391.46 1031.29 387.89 1030.51C358.56 1024.05 359.29 1003.96 359.29 1003.96C358.92 1004.78 358.58 1005.62 358.29 1006.48L357.86 1007.77C356.015 1013.26 356.425 1019.26 359 1024.45V1024.45C360.431 1027.32 362.476 1029.85 364.99 1031.84C367.504 1033.84 370.427 1035.26 373.55 1036L543.07 1075.83L544.24 1071.78Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.73 1022H439.67L434.39 950.11C434.369 949.725 434.426 949.339 434.558 948.976C434.69 948.614 434.895 948.282 435.16 948.001C435.425 947.72 435.744 947.497 436.098 947.343C436.453 947.19 436.834 947.111 437.22 947.11H551.17C551.556 947.111 551.938 947.19 552.292 947.343C552.646 947.497 552.966 947.72 553.231 948.001C553.495 948.282 553.7 948.614 553.833 948.976C553.965 949.339 554.022 949.725 554 950.11L548.73 1022Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(90, 95, 101)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M548.73 1022H439.67L434.39 950.11C434.369 949.725 434.426 949.339 434.558 948.976C434.69 948.614 434.895 948.282 435.16 948.001C435.425 947.72 435.744 947.497 436.098 947.343C436.453 947.19 436.834 947.111 437.22 947.11H551.17C551.556 947.111 551.938 947.19 552.292 947.343C552.646 947.497 552.966 947.72 553.231 948.001C553.495 948.282 553.7 948.614 553.833 948.976C553.965 949.339 554.022 949.725 554 950.11L548.73 1022Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.73 1024.07H439.67L434.39 952.18C434.369 951.795 434.426 951.409 434.558 951.046C434.69 950.684 434.895 950.352 435.16 950.071C435.425 949.79 435.744 949.567 436.098 949.413C436.453 949.26 436.834 949.181 437.22 949.18H551.17C551.556 949.181 551.938 949.26 552.292 949.413C552.646 949.567 552.966 949.79 553.231 950.071C553.495 950.352 553.7 950.684 553.833 951.046C553.965 951.409 554.022 951.795 554 952.18L548.73 1024.07Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(90, 95, 101)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M439.67 1018.55H548.76C548.859 1018.55 548.954 1018.59 549.025 1018.66C549.096 1018.73 549.137 1018.82 549.14 1018.92V1023.69C549.14 1023.79 549.1 1023.89 549.029 1023.96C548.957 1024.03 548.861 1024.07 548.76 1024.07H440C439.904 1024.07 439.812 1024.03 439.741 1023.97C439.671 1023.9 439.627 1023.82 439.62 1023.72L439.27 1018.95C439.265 1018.9 439.273 1018.84 439.291 1018.79C439.31 1018.74 439.339 1018.7 439.377 1018.66C439.415 1018.62 439.461 1018.59 439.512 1018.57C439.562 1018.55 439.616 1018.55 439.67 1018.55V1018.55Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M500.6 986.6C499.756 986.602 498.93 986.363 498.219 985.91C497.507 985.457 496.94 984.81 496.586 984.045C496.231 983.279 496.103 982.429 496.217 981.593C496.331 980.757 496.683 979.972 497.23 979.33C495.668 978.68 493.939 978.549 492.298 978.957C490.657 979.365 489.19 980.291 488.115 981.597C487.041 982.903 486.414 984.52 486.33 986.209C486.245 987.899 486.706 989.57 487.645 990.977C488.583 992.384 489.95 993.452 491.542 994.022C493.134 994.593 494.868 994.636 496.487 994.145C498.105 993.654 499.523 992.656 500.53 991.297C501.537 989.938 502.081 988.291 502.08 986.6C502.085 986.517 502.085 986.433 502.08 986.35C501.605 986.519 501.104 986.603 500.6 986.6Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.018 908.303L558.769 927.693L562.12 932.921L592.369 913.531L589.018 908.303Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.537 913.363L424.162 933.694L427.676 928.573L398.051 908.243L394.537 913.363Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.15 868C490.379 868.007 487.621 867.616 484.96 866.84C481.138 865.723 477.577 863.855 474.487 861.344C471.396 858.834 468.837 855.732 466.96 852.22L471.63 851.04C471.78 851.38 475.7 859.04 486.2 862.09C491.815 863.655 497.789 863.328 503.2 861.16C507.37 859.57 513.2 857.16 514.55 852.35L519.15 853.07C517.64 858.41 512.25 862.96 504.81 865.79C501.09 867.228 497.139 867.977 493.15 868V868Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M549.92 912.78L544.04 905.81L543.07 947.06H550.2L549.92 912.78Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "mask-in-svg",
    style: {
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.47 833.4L466.72 819.24L468.52 805.48L475.07 821.77L475.47 833.4ZM467.64 819.05L474.74 830.63L474.19 821.99L469 808L467.64 819.05Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 187, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.33 829.43L507.16 821V819.88L512.16 801.4L514.1 816.9L508.33 829.43ZM508.07 821.01L508.53 826.68L513.23 816.78L511.88 805.41L508.07 821.01Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 187, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.94 820.21C473.94 820.21 487.78 824.88 507.55 818.72L509.46 827.53C509.46 827.53 505.9 844 491.17 844C491.17 844 480.64 846 473.39 830.54L473.94 820.21Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 187, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M468.52 809.59C468.442 808.824 468.158 808.093 467.699 807.475C467.24 806.856 466.623 806.373 465.912 806.076C465.202 805.779 464.424 805.68 463.662 805.788C462.899 805.896 462.18 806.207 461.58 806.69L461.5 806.78C457.02 810.64 459.92 822.78 469.74 821.7L468.52 809.59Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.39 803.18L517.3 803.1C516.64 802.715 515.888 802.516 515.124 802.521C514.359 802.527 513.611 802.739 512.956 803.133C512.302 803.528 511.766 804.092 511.404 804.765C511.042 805.438 510.868 806.196 510.9 806.96L511.42 818.54C521.34 818.19 522.3 806.34 517.39 803.18Z",
    fill: "#FC9D9D",
    style: {
      baselineShift: 0,
      fill: "rgb(252, 157, 157)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.74 811.08C469.762 811.382 469.664 811.68 469.468 811.911C469.271 812.141 468.992 812.284 468.69 812.31C468.401 812.351 468.108 812.284 467.866 812.121C467.624 811.959 467.451 811.713 467.38 811.43L466.23 803.62L469.48 803.71L469.74 811.08Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.92 807.92C512.922 808.211 512.818 808.493 512.628 808.714C512.438 808.935 512.175 809.08 511.887 809.123C511.599 809.165 511.305 809.103 511.059 808.946C510.814 808.789 510.633 808.549 510.55 808.27L509.41 800.46L512.65 800.55L512.92 807.92Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M466.06 815.91C465.89 815.901 465.729 815.835 465.601 815.722C465.474 815.61 465.389 815.457 465.36 815.29L465.18 813.89C465.154 812.752 464.717 811.661 463.95 810.82C463.808 810.693 463.642 810.596 463.461 810.536C463.281 810.476 463.09 810.453 462.9 810.47C462.725 810.504 462.543 810.468 462.395 810.369C462.247 810.269 462.144 810.115 462.11 809.94C462.075 809.765 462.112 809.583 462.211 809.435C462.311 809.287 462.465 809.185 462.64 809.15C463.381 809.071 464.125 809.259 464.74 809.68C465.296 810.187 465.74 810.805 466.043 811.494C466.347 812.183 466.502 812.927 466.5 813.68L466.67 815.08C466.67 815.265 466.611 815.446 466.501 815.595C466.391 815.744 466.237 815.855 466.06 815.91V815.91Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.46 806.69L495.54 807.22L494.23 807.31L485.54 807.84H485.45L474.31 808.45C473.876 808.474 473.452 808.584 473.061 808.775C472.671 808.965 472.322 809.232 472.036 809.559C471.75 809.886 471.532 810.267 471.396 810.679C471.259 811.091 471.206 811.527 471.24 811.96L471.41 814.5C471.459 815.681 471.742 816.841 472.243 817.912C472.745 818.983 473.454 819.944 474.33 820.739C475.205 821.533 476.23 822.145 477.345 822.54C478.46 822.935 479.642 823.104 480.822 823.038C482.003 822.971 483.159 822.671 484.222 822.154C485.286 821.637 486.236 820.914 487.017 820.026C487.799 819.139 488.396 818.105 488.774 816.984C489.152 815.864 489.304 814.68 489.22 813.5L489.05 810.95C489.013 810.236 488.734 809.555 488.26 809.02L491.68 808.85C491.289 809.44 491.103 810.143 491.15 810.85L491.33 813.39C491.496 815.727 492.575 817.905 494.333 819.453C496.091 821.001 498.388 821.796 500.728 821.664C503.067 821.533 505.26 820.487 506.835 818.751C508.409 817.016 509.237 814.731 509.14 812.39L508.97 809.84C508.951 809.401 508.844 808.971 508.657 808.573C508.469 808.176 508.204 807.82 507.877 807.527C507.55 807.234 507.168 807.009 506.753 806.865C506.338 806.721 505.898 806.662 505.46 806.69ZM487.73 811L487.91 813.55C487.978 815.522 487.271 817.443 485.942 818.902C484.612 820.36 482.765 821.241 480.795 821.356C478.824 821.471 476.887 820.811 475.397 819.517C473.907 818.222 472.982 816.397 472.82 814.43L472.64 811.88C472.612 811.359 472.789 810.848 473.133 810.456C473.477 810.064 473.96 809.821 474.48 809.78L485.63 809.16H485.71C485.966 809.135 486.225 809.164 486.469 809.245C486.714 809.326 486.939 809.457 487.129 809.631C487.319 809.804 487.471 810.016 487.575 810.252C487.678 810.487 487.731 810.742 487.73 811V811ZM507.83 812.41C507.947 814.412 507.263 816.379 505.93 817.877C504.596 819.376 502.722 820.283 500.72 820.4C498.718 820.517 496.751 819.833 495.252 818.5C493.754 817.166 492.847 815.292 492.73 813.29L492.56 810.74C492.53 810.217 492.705 809.704 493.049 809.309C493.393 808.915 493.878 808.671 494.4 808.63L495.72 808.55L505.63 808.02C506.153 807.99 506.666 808.165 507.061 808.509C507.455 808.853 507.699 809.338 507.74 809.86L507.83 812.41Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M514.32 812.31C514.492 812.295 514.652 812.213 514.766 812.083C514.879 811.952 514.938 811.783 514.93 811.61V810.2C514.837 809.649 514.859 809.084 514.995 808.542C515.131 808 515.378 807.492 515.72 807.05C515.846 806.888 516.006 806.756 516.19 806.664C516.373 806.573 516.575 806.523 516.78 806.52C516.867 806.525 516.953 806.513 517.035 806.485C517.118 806.457 517.193 806.413 517.258 806.355C517.323 806.297 517.376 806.228 517.414 806.15C517.452 806.071 517.475 805.987 517.48 805.9C517.485 805.813 517.473 805.726 517.445 805.644C517.417 805.562 517.372 805.487 517.315 805.422C517.257 805.357 517.187 805.304 517.109 805.266C517.031 805.228 516.947 805.205 516.86 805.2C516.495 805.209 516.137 805.292 515.805 805.443C515.474 805.595 515.176 805.811 514.93 806.08C514.06 806.96 513.71 808.36 513.79 810.29V811.7C513.62 812.05 513.88 812.31 514.32 812.31Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.3,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1336.88 758.334L1082.15 757.711C1080.43 757.707 1079.04 759.092 1079.04 760.804L1078.48 990.553C1078.47 992.265 1079.86 993.656 1081.57 993.661L1336.31 994.283C1338.02 994.287 1339.41 992.903 1339.42 991.191L1339.98 761.441C1339.98 759.729 1338.6 758.338 1336.88 758.334Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 187, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    style: {
      baselineShift: 0,
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1336.88 758.334L1082.15 757.711C1080.43 757.707 1079.04 759.092 1079.04 760.804L1078.48 990.553C1078.47 992.265 1079.86 993.656 1081.57 993.661L1336.31 994.283C1338.02 994.287 1339.41 992.903 1339.42 991.191L1339.98 761.441C1339.98 759.729 1338.6 758.338 1336.88 758.334Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1331.28 758.34L1076.54 757.718C1074.83 757.713 1073.44 759.098 1073.44 760.81L1072.88 990.559C1072.87 992.272 1074.26 993.663 1075.97 993.667L1330.71 994.289C1332.42 994.294 1333.81 992.909 1333.82 991.197L1334.38 761.448C1334.38 759.736 1333 758.344 1331.28 758.34Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322.69 771.05H1084.71V953.64H1322.69V771.05Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 187, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M1322.69 771.05H1084.71V953.64H1322.69V771.05Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.97 953.63L1168.62 833.88L1219.86 908.77L1254.59 868.72L1322.7 953.57L1085.97 953.63Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 187, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.3 817.59C1235.3 826.76 1228.37 834.2 1219.81 834.2C1211.25 834.2 1204.31 826.77 1204.31 817.6C1204.31 808.43 1211.24 801 1219.8 801C1228.36 801 1235.3 808.42 1235.3 817.59Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 187, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1226.45 802.61C1228.31 804.224 1229.79 806.223 1230.8 808.467C1231.81 810.712 1232.32 813.149 1232.3 815.61C1232.3 824.78 1225.37 832.22 1216.81 832.22C1214.5 832.215 1212.22 831.66 1210.16 830.6C1212.84 832.923 1216.26 834.208 1219.81 834.22C1228.37 834.22 1235.3 826.78 1235.3 817.61C1235.35 814.537 1234.55 811.511 1232.99 808.864C1231.43 806.217 1229.16 804.053 1226.45 802.61V802.61Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1255.04 868.52L1297.64 953.67L1322.26 953.48L1255.04 868.52Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1168.22 833.98L1203.7 929.21L1219.57 908.67L1168.22 833.98Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.81 414.77H250.05C245.742 414.77 242.25 418.262 242.25 422.57V702.8C242.25 707.108 245.742 710.6 250.05 710.6H648.81C653.118 710.6 656.61 707.108 656.61 702.8V422.57C656.61 418.262 653.118 414.77 648.81 414.77Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 187, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M648.81 414.77H250.05C245.742 414.77 242.25 418.262 242.25 422.57V702.8C242.25 707.108 245.742 710.6 250.05 710.6H648.81C653.118 710.6 656.61 707.108 656.61 702.8V422.57C656.61 418.262 653.118 414.77 648.81 414.77Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.2 415.21H244.44C240.132 415.21 236.64 418.702 236.64 423.01V703.24C236.64 707.548 240.132 711.04 244.44 711.04H643.2C647.508 711.04 651 707.548 651 703.24V423.01C651 418.702 647.508 415.21 643.2 415.21Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 187, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M643.2 415.21H244.44C240.132 415.21 236.64 418.702 236.64 423.01V703.24C236.64 707.548 240.132 711.04 244.44 711.04H643.2C647.508 711.04 651 707.548 651 703.24V423.01C651 418.702 647.508 415.21 643.2 415.21Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.86 679.27H248.77V680.1H638.86V679.27Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.03 691.01H629.27V694.81H630.03V691.01Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.02 691.01H629.31V691.77H633.02V691.01Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.36 691.04H635.56V691.8H639.36V691.04Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.36 691.08H638.6V694.79H639.36V691.08Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.36 696.98H638.6V700.78H639.36V696.98Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.32 700.02H635.61V700.78H639.32V700.02Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.07 699.99H629.27V700.75H633.07V699.99Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.03 697.01H629.27V700.72H630.03V697.01Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.55 694.46H270.96C270.17 694.46 269.53 695.1 269.53 695.89V695.9C269.53 696.69 270.17 697.33 270.96 697.33H585.55C586.34 697.33 586.98 696.69 586.98 695.9V695.89C586.98 695.1 586.34 694.46 585.55 694.46Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.67 694.46H270.96C270.17 694.46 269.53 695.1 269.53 695.89V695.9C269.53 696.69 270.17 697.33 270.96 697.33H440.67C441.46 697.33 442.1 696.69 442.1 695.9V695.89C442.1 695.1 441.46 694.46 440.67 694.46Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 187, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M440.67 694.46H270.96C270.17 694.46 269.53 695.1 269.53 695.89V695.9C269.53 696.69 270.17 697.33 270.96 697.33H440.67C441.46 697.33 442.1 696.69 442.1 695.9V695.89C442.1 695.1 441.46 694.46 440.67 694.46Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.1,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.93 696.11V696.84H598.18V696.11H600.93Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.36 696.11V696.84H601.6V696.11H604.36Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.68 699.94L607.79 691.85H608.55L605.43 699.94H604.68Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.61 696.11V696.84H608.85V696.11H611.61Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615 696.11V696.84H612.25V696.11H615Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.28 695.9L253.57 690.87V700.92L262.28 695.9Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.971 584.274C477.327 571.918 477.875 552.433 466.194 540.752C454.514 529.071 435.028 529.619 422.672 541.975C410.316 554.332 409.768 573.817 421.448 585.498C433.129 597.178 452.615 596.631 464.971 584.274Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 187, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.4 563.13L433 546.73V579.52L461.4 563.13Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.39 618.36H1128.61C1127.61 618.36 1126.62 618.558 1125.69 618.942C1124.77 619.326 1123.93 619.89 1123.22 620.599C1122.51 621.309 1121.95 622.152 1121.57 623.079C1121.19 624.005 1121 624.998 1121 626V657C1121 659.019 1121.8 660.956 1123.23 662.385C1124.66 663.813 1126.59 664.617 1128.61 664.62H1133.73L1133.98 681.62L1145.98 664.62H1298.34C1299.34 664.625 1300.34 664.432 1301.27 664.051C1302.2 663.671 1303.04 663.11 1303.75 662.402C1304.47 661.694 1305.03 660.852 1305.42 659.925C1305.8 658.998 1306 658.004 1306 657V626C1306 624.998 1305.81 624.005 1305.43 623.079C1305.05 622.152 1304.49 621.309 1303.78 620.599C1303.07 619.89 1302.23 619.326 1301.31 618.942C1300.38 618.558 1299.39 618.36 1298.39 618.36Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(43, 131, 252)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1298.39 618.36H1128.61C1127.61 618.36 1126.62 618.558 1125.69 618.942C1124.77 619.326 1123.93 619.89 1123.22 620.599C1122.51 621.309 1121.95 622.152 1121.57 623.079C1121.19 624.005 1121 624.998 1121 626V657C1121 659.019 1121.8 660.956 1123.23 662.385C1124.66 663.813 1126.59 664.617 1128.61 664.62H1133.73L1133.98 681.62L1145.98 664.62H1298.34C1299.34 664.625 1300.34 664.432 1301.27 664.051C1302.2 663.671 1303.04 663.11 1303.75 662.402C1304.47 661.694 1305.03 660.852 1305.42 659.925C1305.8 658.998 1306 658.004 1306 657V626C1306 624.998 1305.81 624.005 1305.43 623.079C1305.05 622.152 1304.49 621.309 1303.78 620.599C1303.07 619.89 1302.23 619.326 1301.31 618.942C1300.38 618.558 1299.39 618.36 1298.39 618.36Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1289.19 634.1H1137.8V637.79H1289.19V634.1Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164.69 645.17H1137.8V648.86H1164.69V645.17Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.41 645.17H1170.59V648.86H1236.41V645.17Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.58 762.63H435.42C437.164 762.633 438.836 763.327 440.07 764.56C441.303 765.794 441.997 767.466 442 769.21V796.05C441.997 797.794 441.303 799.466 440.07 800.7C438.836 801.933 437.164 802.627 435.42 802.63H431L430.78 817.37L420.36 802.63H288.58C286.836 802.627 285.164 801.933 283.93 800.7C282.697 799.466 282.003 797.794 282 796.05V769.21C282.003 767.466 282.697 765.794 283.93 764.56C285.164 763.327 286.836 762.633 288.58 762.63Z",
    className: "change-color-in-svg-1",
    fill: "#15247C",
    style: {
      fill: "rgb(43, 131, 252)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M288.58 762.63H435.42C437.164 762.633 438.836 763.327 440.07 764.56C441.303 765.794 441.997 767.466 442 769.21V796.05C441.997 797.794 441.303 799.466 440.07 800.7C438.836 801.933 437.164 802.627 435.42 802.63H431L430.78 817.37L420.36 802.63H288.58C286.836 802.627 285.164 801.933 283.93 800.7C282.697 799.466 282.003 797.794 282 796.05V769.21C282.003 767.466 282.697 765.794 283.93 764.56C285.164 763.327 286.836 762.633 288.58 762.63Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.54 779.44H427.47V776.25H296.54V779.44Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.22 789.01H427.47V785.82H404.22V789.01Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.18 789.01H399.11V785.82H342.18V789.01Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.78 603.31H869.89C866.51 603.31 863.269 604.652 860.878 607.041C858.487 609.43 857.143 612.67 857.14 616.05V742C857.143 745.38 858.487 748.62 860.878 751.009C863.269 753.398 866.51 754.74 869.89 754.74H995.77C999.152 754.74 1002.39 753.397 1004.79 751.006C1007.18 748.615 1008.52 745.372 1008.52 741.99V616.06C1008.52 612.68 1007.18 609.439 1004.79 607.048C1002.4 604.657 999.16 603.313 995.78 603.31V603.31Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(90, 95, 101)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M995.78 603.31H869.89C866.51 603.31 863.269 604.652 860.878 607.041C858.487 609.43 857.143 612.67 857.14 616.05V742C857.143 745.38 858.487 748.62 860.878 751.009C863.269 753.398 866.51 754.74 869.89 754.74H995.77C999.152 754.74 1002.39 753.397 1004.79 751.006C1007.18 748.615 1008.52 745.372 1008.52 741.99V616.06C1008.52 612.68 1007.18 609.439 1004.79 607.048C1002.4 604.657 999.16 603.313 995.78 603.31V603.31Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.11 603.31H864.23C860.848 603.31 857.606 604.653 855.214 607.044C852.823 609.435 851.48 612.678 851.48 616.06V741.94C851.48 745.322 852.823 748.565 855.214 750.956C857.606 753.347 860.848 754.69 864.23 754.69H990.11C993.481 754.69 996.715 753.355 999.104 750.977C1001.49 748.599 1002.84 745.371 1002.86 742V616.06C1002.86 612.678 1001.52 609.435 999.126 607.044C996.735 604.653 993.491 603.31 990.11 603.31Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(90, 95, 101)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M990.11 603.31H864.23C860.848 603.31 857.606 604.653 855.214 607.044C852.823 609.435 851.48 612.678 851.48 616.06V741.94C851.48 745.322 852.823 748.565 855.214 750.956C857.606 753.347 860.848 754.69 864.23 754.69H990.11C993.481 754.69 996.715 753.355 999.104 750.977C1001.49 748.599 1002.84 745.371 1002.86 742V616.06C1002.86 612.678 1001.52 609.435 999.126 607.044C996.735 604.653 993.491 603.31 990.11 603.31Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.42 720.08C972.799 720.102 971.179 719.978 969.58 719.71L969.2 719.6C968.457 719.363 967.774 718.968 967.2 718.44C966.062 716.89 965.109 715.212 964.36 713.44C962.98 710.607 961.767 707.993 960.72 705.6L957.12 697.12L930.44 634.33L930.14 633.62H926L925.7 634.33C922.58 641.73 919.453 649.123 916.32 656.51L899.12 695.51L892.48 709.93C890.37 714.49 888.97 717.17 888.27 718C887.658 718.767 886.834 719.338 885.9 719.64C885.521 719.751 885.133 719.828 884.74 719.87C883.66 720 882.06 720.09 879.96 720.12L879.39 720.62V723.91L879.96 724.41C884.68 724.083 889.347 723.917 893.96 723.91C898.04 723.91 902.803 724.077 908.25 724.41L908.76 723.91V720.62L908.19 720.12C903.6 720.12 900.72 719.8 899.58 719.29C899.086 719.131 898.656 718.819 898.35 718.4C898.047 717.981 897.883 717.477 897.88 716.96C898.111 714.739 898.731 712.576 899.71 710.57L906.61 694.37H943.23L951 713.67C951.513 714.831 951.818 716.073 951.9 717.34C951.919 717.858 951.749 718.365 951.421 718.766C951.094 719.167 950.631 719.435 950.12 719.52C947.193 719.979 944.232 720.18 941.27 720.12L940.76 720.62V723.91L941.27 724.41C948.263 724.25 955.263 724.063 962.27 723.85C964.17 723.85 966.193 723.9 968.34 724C970.24 724.1 972.25 724.24 974.34 724.41L974.51 724.24L974.84 723.91V720.62L974.42 720.08ZM908.84 688.89L925 650.76L940.87 688.89H908.84Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.27 639V628.28H969.58V632.92H884.77V628.28H874.08V639H878.71V719.08H874.08V729.76H884.77V725.12H969.58V729.76H980.27V719H975.63V639H980.27ZM884.77 723.71V719.08H880.13V639H884.77V634.37H969.58V639H974.21V719.08H969.58V723.71H884.77Z",
    className: "change-color-in-svg-3",
    fill: "#00BC7D",
    style: {
      fill: "rgb(90, 95, 101)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M980.27 639V628.28H969.58V632.92H884.77V628.28H874.08V639H878.71V719.08H874.08V729.76H884.77V725.12H969.58V729.76H980.27V719H975.63V639H980.27ZM884.77 723.71V719.08H880.13V639H884.77V634.37H969.58V639H974.21V719.08H969.58V723.71H884.77Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.4,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.26 797H675.37C671.99 797 668.749 798.342 666.358 800.731C663.967 803.12 662.623 806.36 662.62 809.74V935.64C662.623 939.02 663.967 942.26 666.358 944.649C668.749 947.038 671.99 948.38 675.37 948.38H801.25C802.929 948.38 804.591 948.049 806.141 947.405C807.691 946.761 809.099 945.817 810.283 944.628C811.468 943.439 812.406 942.027 813.044 940.475C813.682 938.922 814.007 937.259 814 935.58V809.7C813.987 806.329 812.639 803.1 810.252 800.72C807.864 798.34 804.631 797.003 801.26 797Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 187, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M801.26 797H675.37C671.99 797 668.749 798.342 666.358 800.731C663.967 803.12 662.623 806.36 662.62 809.74V935.64C662.623 939.02 663.967 942.26 666.358 944.649C668.749 947.038 671.99 948.38 675.37 948.38H801.25C802.929 948.38 804.591 948.049 806.141 947.405C807.691 946.761 809.099 945.817 810.283 944.628C811.468 943.439 812.406 942.027 813.044 940.475C813.682 938.922 814.007 937.259 814 935.58V809.7C813.987 806.329 812.639 803.1 810.252 800.72C807.864 798.34 804.631 797.003 801.26 797Z",
    fill: "black",
    style: {
      baselineShift: 0,
      fill: "rgb(0, 0, 0)",
      opacity: 0.2,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.59 797H669.71C666.344 797.011 663.119 798.352 660.738 800.731C658.357 803.11 657.013 806.334 657 809.7V935.58C657 938.962 658.343 942.204 660.734 944.596C663.125 946.987 666.368 948.33 669.75 948.33H795.59C798.97 948.33 802.211 946.988 804.602 944.599C806.993 942.21 808.337 938.97 808.34 935.59V809.7C808.327 806.327 806.978 803.097 804.588 800.717C802.198 798.336 798.963 797 795.59 797V797Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 187, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.59 797H669.71C666.344 797.011 663.119 798.352 660.738 800.731C658.357 803.11 657.013 806.334 657 809.7V935.58C657 938.962 658.343 942.204 660.734 944.596C663.125 946.987 666.368 948.33 669.75 948.33H795.59C798.97 948.33 802.211 946.988 804.602 944.599C806.993 942.21 808.337 938.97 808.34 935.59V809.7C808.327 806.327 806.978 803.097 804.588 800.717C802.198 798.336 798.963 797 795.59 797V797Z",
    className: "change-color-in-svg-2",
    fill: "#3562FF",
    style: {
      fill: "rgb(255, 187, 0)",
      baselineShift: 0,
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.57 847.57L761.75 833.07C761.767 832.835 761.73 832.598 761.64 832.38C761.551 832.161 761.412 831.967 761.235 831.811C761.058 831.655 760.847 831.542 760.619 831.481C760.391 831.42 760.152 831.413 759.92 831.46L715.58 838.52C715.059 838.617 714.587 838.89 714.242 839.291C713.897 839.693 713.698 840.2 713.68 840.73V895.29C711.072 893.239 707.849 892.126 704.53 892.13C697.36 892.13 691.53 896.99 691.53 902.99C691.53 908.99 697.34 913.85 704.53 913.85C711.72 913.85 717.53 908.99 717.53 902.99C717.53 902.5 717.53 902.4 717.53 901.6C717.546 901.354 717.546 901.106 717.53 900.86V866V861.23L757.76 854.52V888.89C755.178 886.834 751.971 885.719 748.67 885.73C741.5 885.73 735.72 890.59 735.72 896.59C735.72 902.59 741.55 907.44 748.72 907.44C755.89 907.44 761.72 902.63 761.72 896.63C761.72 896.14 761.72 895.94 761.72 895.16C761.732 894.927 761.732 894.693 761.72 894.46V859.48L761.57 847.57Z",
    fill: "white",
    style: {
      baselineShift: 0,
      fill: "rgb(255, 255, 255)",
      paintOrder: "normal",
      textDecoration: "none solid rgb(61, 61, 61)"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero2);
export default __webpack_public_path__ + "static/media/Hero2.9b9dcc0fa57b3798ce0ba579e0801858.svg";
export { ForwardRef as ReactComponent };